export default "__VITE_ASSET__CT5YsxjV__"